import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { hasCookieConsent, saveCookieConsent } from "../utils/cookieConsent";
import { COOKIE_POLICY_VERSION } from "../constants/legal";

const API_URL = process.env.REACT_APP_API_URL;

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(
    () => !hasCookieConsent(COOKIE_POLICY_VERSION),
  );

  const handleAccept = () => {
    saveCookieConsent(COOKIE_POLICY_VERSION);
    setVisible(false);
    window.dispatchEvent(new Event("cookie-consent-changed"));

    const token = localStorage.getItem("token");
    axios
      .post(
        `${API_URL}/consent/cookies`,
        { version: COOKIE_POLICY_VERSION },
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined,
      )
      .catch(() => {});
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[95] flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-gray-700 bg-gray-900 px-4 py-3 text-sm text-gray-200 shadow-lg">
      <p className="text-center sm:text-left">
        Usamos cookies propias y de terceros para el funcionamiento del
        sitio. Al continuar navegando aceptas nuestro{" "}
        <Link
          to="/politica-privacidad#cookies"
          className="underline hover:text-white"
          target="_blank"
        >
          uso de cookies
        </Link>
        .
      </p>
      <Button onClick={handleAccept} className="whitespace-nowrap">
        Aceptar
      </Button>
    </div>
  );
};

export default CookieConsentBanner;
